module.exports = __webpack_public_path__ + "img/success_logo.d995c583.svg";